// import axios from 'axios';
// import React, { useEffect, useState } from 'react'
// import { Link, useParams,useNavigate } from 'react-router-dom';
// import Layout from '../../Layout/Layout';
// import DetailsSection2 from './DetailsSection2';
// import Footer from '../../Layout/Footer';

// const BASE_URL = "https://ecom.cyberathon.com"; 
// function DetailsSection1() {
//   const [BannerUser, setBannerUser] = useState({
//     Product_image:"",
//     Product_name: "",
//     category_id: "",
//     discription: "",
//     old_price: "",
//     current_price: "",
//     discount: "",
//     rating: "",
//      pdetails_sheading:"",
//     large_description:"",
//     stock_status:"",
//   });

  
//   const { prod_id } = useParams();   

// useEffect(() => {
//   const BannerData = async () => {
//     try {
//       const response = await axios.post(
//         "https://ecom.cyberathon.com/index.php/Api/get_by_id_create_product",
//         { prod_id: prod_id } 
//       );

//       if (response.data.products && response.data.products.length > 0) {
//         setBannerUser(response.data.products[0]);
//       } else {
//         console.error("No product found for this ID");
//       }
//     } catch (error) {
//       console.error("There was an error!", error);
//     }
//   };
//   BannerData();
// }, [prod_id]);
// //Additional start start
//  const renderStars = (rating) => {
//     const stars = [];
//     const fullStars = Math.floor(rating);      
//     const hasHalfStar = rating % 1 !== 0;       
//     const emptyStars = 5 - Math.ceil(rating);   

//     for (let i = 0; i < fullStars; i++) {
//       stars.push(<i key={"f" + i} className="fa-solid fa-star text-warning"></i>);
//     }
//     if (hasHalfStar) {
//       stars.push(<i key="half" className="fa-solid fa-star-half-stroke text-warning"></i>);
//     }
//     for (let i = 0; i < emptyStars; i++) {
//       stars.push(<i key={"e" + i} className="fa-regular fa-star text-warning"></i>);
//     }

//     return stars;
//   };
//   // Addition start end
// const navigate = useNavigate();
// // const handleAddToCart = () => {
// //   let cart = JSON.parse(localStorage.getItem("cartItems")) || [];

// //    const productToAdd = {
// //     prod_id: BannerUser.prod_id,
// //     Product_name: BannerUser.Product_name,
// //     Product_image: BannerUser.Product_image,
// //     discription: BannerUser.discription,
// //     current_price: BannerUser.current_price,
// //     old_price: BannerUser.old_price,
// //     discount: BannerUser.discount,
// //     rating: BannerUser.rating,
// //     quantity: 1
// //   };

// //   console.log("FINAL PRODUCT ADDED:", productToAdd);
  
// //   // --- prevent duplicate ---
// //   const isExist = cart.some(item => item.prod_id === BannerUser.prod_id);

// //   if (!isExist) {
// //     cart.push(BannerUser);
// //     localStorage.setItem("cartItems", JSON.stringify(cart));
// //   }

// //   // --- redirect to cart page ---
// //   // navigate(`/functioncart/${BannerUser.prod_id1}`);
// //     // navigate(`/functioncart/${BannerUser.prod_id1}`);
// //     navigate(`/functioncart`);

// // };


// const handleAddToCart = () => {
//   const isLoggedIn = sessionStorage.getItem("isLoggedIn") === "true";
//   const userEmail = sessionStorage.getItem("userEmail");

//   // --------- CART STORAGE LOGIC ----------
//   let cartKey = isLoggedIn ? `cart_${userEmail}` : "guest_cart";
//   let cart = JSON.parse(localStorage.getItem(cartKey)) || [];

//   const productToAdd = {
//     prod_id: BannerUser.prod_id,
//     Product_name: BannerUser.Product_name,
//     Product_image: BannerUser.Product_image,
//     discription: BannerUser.discription,
//     current_price: BannerUser.current_price,
//     old_price: BannerUser.old_price,
//     discount: BannerUser.discount,
//     rating: BannerUser.rating,
//     quantity: 1
//   };

//   // --------- CHECK IF PRODUCT ALREADY EXISTS ----------
//   const existIndex = cart.findIndex(item => item.prod_id == BannerUser.prod_id);

//   if (existIndex !== -1) {
//     // Increase quantity if already exists
//     cart[existIndex].quantity += 1;
//   } else {
//     cart.push(productToAdd);
//   }

//   // --------- SAVE UPDATED CART ----------
//   localStorage.setItem(cartKey, JSON.stringify(cart));

//   // --------- REDIRECT TO CART ----------
//   navigate("/functioncart");
// };

//   return (
   
//    <>
//     <Layout/>
//       <div className="container-fluid py-5">
//         <div className="row align-items-start">
//           <div className="col-12 col-lg-5 col-md-6">
//             <img
//               src={`${BASE_URL}/${BannerUser.Product_image}`}
//               alt="img1"
//               className="img-fluid imgsize"
//             ></img>
//           </div>
//           <div className="col-12 col-lg-7 col-md-6 p-5">
//             <p className="text-primary fw-bold">ALLERGIES</p>
//             <h2 className="fw-bold">{BannerUser.Product_name}</h2>
//             <p className="text-muted">
//               {/* ⭐⭐⭐⭐⭐ 3 &nbsp; &nbsp; SKU:<b>S5T6U7V8</b> */}
//                             {renderStars(BannerUser.rating)} 3 &nbsp; &nbsp; SKU:<b>S5T6U7V8</b>

//             </p>
//             <hr />
//             <div className="d-flex align-items-center mb-3 justify-content-between">
//               <div className="d-flex align-items-center">
//                 <h1 className="text-success me-2 fw-bold mb-0">{BannerUser.current_price}</h1>
//                 <h3 className="text-decoration-line-through text-muted mb-0">
//                   {BannerUser.old_price}
//                 </h3>
//               </div>
//               <span className="badge bg-light text-success">In Stock</span>
//             </div>
//             <p>
//               {BannerUser.discription}
//             </p>

//             <div className="d-flex align-items-center">
//               <button class="btn btn-outline-secondary bg-light" type="button">
//                 - 1 +
//               </button>
//               {/* <Link to={`/functioncart/${BannerUser.prod_id}`}>
//                   <button className="border-0 rounded-1 bg-col text-light p-2 ms-2" >Add to cart</button>
//               </Link> */}
//               <button 
//   className="border-0 rounded-1 bg-col text-light p-2 ms-2"
//   onClick={handleAddToCart}
// >
//   Add to cart
// </button>
//             </div>

//             <div className="pt-4">
//               <table className="table table-bordered table-hover">
//                 <tbody>
//                   <tr>
//                     <td>Free Shipping & Returns on this item</td>
//                   </tr>
//                   <tr>
//                     <td>Delivery within 3-5 working days</td>
//                   </tr>
//                   <tr>
//                     <td>Money Back Guarantee</td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="container-fluid p-5">
//         <h3 className="text-decoration-underline">Description</h3>
//         <hr></hr>
        
//         <p>Cutter BiteMD Insect Bite Relief Stick is an external analgesic and first aid antiseptic pen that provides fast and effective relief from insect bites and stings. When applied soon after an insect bite, this product begins to work immediately to counteract the effects of bites and stings from bees, wasps, mosquitoes, ticks, hornets, ants, fire ants, deerflies, chiggers, sand fleas and horseflies. Use as first aid for temporary relief from pain, itching and infection related to insect bites. The Cutter BiteMD Insect Bite Relief Stick applicator features a soft tip for controlled application.</p>
//         <p> FAST RELIEF: Begins to work immediately when applied soon after an insect bite.</p>
//         <p> STOPS PAIN, RELIEVES ITCHING: Works on bites and stings from chiggers, wasps, mosquitoes, ticks and other listed insects.</p>
//         <p> REDUCES INFECTION: First aid antiseptic reduces the chance of infection.
//         CONVENIENT STICK: The stick applicator easily fits in a pocket – handy for hiking and traveling.</p>
//        <p>SOFT TIP: Pen applicator features a soft tip for controlled application.</p>
//       </div>
//       <DetailsSection2/>
//     <Footer/>
//     </>
//   )
// }

// export default DetailsSection1;




import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../../Layout/Layout';
import DetailsSection2 from './DetailsSection2';
import Footer from '../../Layout/Footer';
import DetailsSection2dynamic from './DetailsSection2dynamic';

const BASE_URL = "https://ecom.cyberathon.com"; 

function DetailsSection1() {
  const [BannerUser, setBannerUser] = useState({
    Product_image:"",
    Product_name: "",
    category_id: "",
    discription: "",
    old_price: "",
    current_price: "",
    discount: "",
    rating: "",
    pdetails_sheading:"",
    large_description:"",
    stock_status:"",
  });

  const { prod_id } = useParams();   
  const navigate = useNavigate();

  // Fetch product details
  useEffect(() => {
    const BannerData = async () => {
      try {
        const response = await axios.post(
          `${BASE_URL}/index.php/Api/get_by_id_create_product`,
          { prod_id } 
        );

        if (response.data.products && response.data.products.length > 0) {
          setBannerUser(response.data.products[0]);
        } else {
          console.error("No product found for this ID");
        }
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    BannerData();
  }, [prod_id]);

  // Star rating render
  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);      
    const hasHalfStar = rating % 1 !== 0;       
    const emptyStars = 5 - Math.ceil(rating);   

    for (let i = 0; i < fullStars; i++) stars.push(<i key={"f" + i} className="fa-solid fa-star text-warning"></i>);
    if (hasHalfStar) stars.push(<i key="half" className="fa-solid fa-star-half-stroke text-warning"></i>);
    for (let i = 0; i < emptyStars; i++) stars.push(<i key={"e" + i} className="fa-regular fa-star text-warning"></i>);

    return stars;
  };

  // 🟢 Final Add to Cart using API
  const handleAddToCart = async () => {
    // const isLoggedIn = sessionStorage.getItem("isLoggedIn") === "true";
    const userId = sessionStorage.getItem("userId") || 0; // backend requires user_id

    // if (!isLoggedIn) {
    //   alert("Please login to add to cart");
    //   return;
    // }

    try {
      const response = await axios.post(
        `${BASE_URL}/index.php/Api/insert_cart`,
        {
          user_id: userId,
          prod_id: BannerUser.prod_id,
          qty: 1
        },
        {
          headers: { "Content-Type": "application/json" }
        }
      );

      if (response.data.status === true) {
        // alert("Product added to cart!");
        navigate("/functioncart"); // Redirect to cart page
      } else {
        alert(response.data.message || "Failed to add to cart");
      }
    } catch (error) {
      console.error(error);
      alert("API Error while adding to cart");
    }
  };

  return (
    <>
      <Layout/>
      <div className="container-fluid py-5">
        <div className="row align-items-start">
          <div className="col-12 col-lg-5 col-md-6">
            <img
              src={`${BASE_URL}/${BannerUser.Product_image}`}
              alt={BannerUser.Product_name}
              className="img-fluid imgsize"
            />
          </div>

          <div className="col-12 col-lg-7 col-md-6 p-5">
            <p className="text-primary fw-bold">ALLERGIES</p>
            <h2 className="fw-bold">{BannerUser.Product_name}</h2>
            <p className="text-muted">
              {renderStars(BannerUser.rating)} 3 &nbsp; &nbsp; SKU:<b>S5T6U7V8</b>
            </p>
            <hr />

            <div className="d-flex align-items-center mb-3 justify-content-between">
              <div className="d-flex align-items-center">
                <h1 className="text-success me-2 fw-bold mb-0">{BannerUser.current_price}</h1>
                <h3 className="text-decoration-line-through text-muted mb-0">{BannerUser.old_price}</h3>
              </div>
              <span className="badge bg-light text-success">In Stock</span>
            </div>

            <p>{BannerUser.discription}</p>

            <div className="d-flex align-items-center">
              <button className="btn btn-outline-secondary bg-light" type="button">- 1 +</button>
              <button 
                className="border-0 rounded-1 bg-col text-light p-2 ms-2"
                onClick={handleAddToCart}
              >
                Add to cart
              </button>
            </div>

            <div className="pt-4">
              <table className="table table-bordered table-hover">
                <tbody>
                  <tr><td>{BannerUser.shipping} Shipping & Returns on this item</td></tr>
                  <tr><td>Delivery within 3-5 working days</td></tr>
                  <tr><td>Money Back Guarantee</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid p-5">
        <h3 className="text-decoration-underline">Description</h3>
        <hr/>
        <p>{BannerUser.large_description || BannerUser.discription}</p>
      </div>

      {/* <DetailsSection2/> */}
      <DetailsSection2dynamic/>
      <Footer/>
    </>
  )
}

export default DetailsSection1;
